if (!customElements.get('mg-shipping-progress')) {
  class MotusShippingProgress extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      this.message = this.querySelector('[data-mg-shipping-message]');
      this.meter = this.querySelector('[data-mg-shipping-meter]');
      this.scope = this.querySelector('[data-mg-shipping-scope]');
      this.update = event => this.render(event.detail);
      document.addEventListener('mg:cart-updated', this.update, {signal:this.abort.signal});
      this.render({currency:this.dataset.currency,total_price:Number(this.dataset.total),taxes_included:this.dataset.taxesIncluded === 'true'});
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.abort = null;
    }
    render(cart) {
      if (!cart || !Number.isFinite(cart.total_price)) return;
      const numeric = cart.currency === 'CAD' && cart.taxes_included === false;
      this.meter.hidden = !numeric;
      this.scope.hidden = !numeric;
      if (!numeric) {
        this.message.textContent = this.dataset.otherText;
        return;
      }
      const remaining = Math.max(0, 20000 - cart.total_price);
      const amount = new Intl.NumberFormat(document.documentElement.lang || 'en-CA', {style:'currency',currency:'CAD',currencyDisplay:'code'}).format(remaining / 100);
      this.message.textContent = remaining > 0 ? this.dataset.remainingText.replace('[amount]', amount) : this.dataset.qualifiedText;
      this.meter.value = Math.max(0, Math.min(20000, cart.total_price));
    }
  }
  customElements.define('mg-shipping-progress', MotusShippingProgress);
}
